import { z } from "zod";

export function createTaskFormSchema() {
  return z.object({
    title: z
      .string()
      .min(1, "taskForm.errors.titleRequired")
      .max(200, "taskForm.errors.titleMax"),
    description: z
      .string()
      .max(2000, "taskForm.errors.descriptionMax")
      .optional()
      .or(z.literal("")),
    status: z.enum(["backlog", "todo", "in_progress", "blocked", "done"], {
      message: "taskForm.errors.statusRequired",
    }),
    priority: z.enum(["low", "normal", "high", "critical"], {
      message: "taskForm.errors.priorityRequired",
    }),
    assigned_to: z.number().nullable().optional(),
    due_date: z.string().optional().or(z.literal("")),
    tags: z.array(z.object({
      text: z.string(),
      color: z.enum(["gray", "info", "positive", "notice", "negative", "primary", "yellow", "indigo", "pink", "lime", "cyan"]),
    })),
    is_kpi: z.boolean(),
    parent_task: z.number().nullable().optional(),
    requires_fsm_report: z.boolean(),
  });
}

export const taskFormSchema = createTaskFormSchema();

export type TaskFormValues = z.infer<ReturnType<typeof createTaskFormSchema>>;

export const MAX_COMMENT_FILES = 3;
export const MAX_COMMENT_FILE_SIZE_MB = 10;
export const ALLOWED_COMMENT_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
];
export const ALLOWED_COMMENT_FILE_EXTENSIONS = ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.webp";

export function createCommentFormSchema() {
  return z.object({
    body: z.string(),
  });
}

export const commentFormSchema = createCommentFormSchema();

export type CommentFormValues = z.infer<ReturnType<typeof createCommentFormSchema>>;
